export default __webpack_public_path__ + "static/media/illustration_3.ca7ecf65.png";